export default __webpack_public_path__ + "static/media/3745.e115a4ca.png";